"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifiedAddressAutocomplete = exports.VerifiedAddressSelect = void 0;
// tslint:disable:jsx-no-multiline-js
// tslint:disable:jsx-no-lambda
var react_1 = __importDefault(require("react"));
var List_1 = require("./List");
var Autocomplete_1 = require("./Autocomplete");
var Display_1 = require("./Display");
var VerifiedAddressSelect = function (props) { return (react_1.default.createElement(List_1.VerifiedAddressList, null, function (items) { return (react_1.default.createElement("select", __assign({}, props),
    react_1.default.createElement("option", null, "Select One"),
    items.map(function (item) { return (react_1.default.createElement("option", { key: item.id, value: item.address }, item.name || item.address)); }))); })); };
exports.VerifiedAddressSelect = VerifiedAddressSelect;
var VerifiedAddressAutocomplete = function (props) { return (react_1.default.createElement(Autocomplete_1.Autocomplete, __assign({}, props),
    react_1.default.createElement(Autocomplete_1.AutocompleteMenu, null, function (onSelect) { return (react_1.default.createElement(List_1.VerifiedAddressList, null, function (items) {
        return items.map(function (item) { return (react_1.default.createElement("li", { className: 'list-group-item list-group-item-action', style: { cursor: 'pointer' }, onClick: function () { return onSelect(item.address); }, key: item.id },
            react_1.default.createElement(Display_1.VerifiedAddressItem, __assign({}, item)))); });
    })); }))); };
exports.VerifiedAddressAutocomplete = VerifiedAddressAutocomplete;
//# sourceMappingURL=Select.js.map